import { render, staticRenderFns } from "./FormGroupSelectable.vue?vue&type=template&id=2851dc94"
import script from "./FormGroupSelectable.vue?vue&type=script&lang=js"
export * from "./FormGroupSelectable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports